import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BACKEND_URL } from './config'; // Import the centralized config

const PlatformConnections = () => {
  const [platformStatus, setPlatformStatus] = useState({
    loginStatus: { tiktok: false, instagram: false, facebook: false, twitter: false, youtube: false },
    userDetails: { tiktok: null, instagram: null, twitter: null, youtube: null },
    validationErrors: { tiktok: null, instagram: null, twitter: null, youtube: null },
    needsReconnect: { tiktok: false, instagram: false, facebook: false, twitter: false, youtube: false },
  });

  const fetchPlatformStatus = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/check-platform-login`, {
        withCredentials: true,
      });
      setPlatformStatus(response.data);
    } catch (error) {
      console.error('Error fetching platform status:', error);
    }
  };

  const connectPlatform = async (platform) => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/${platform}/auth`, {
        withCredentials: true,
      });
      window.location.href = response.data.authUrl; // Redirect to OAuth URL
    } catch (error) {
      console.error(`Error connecting to ${platform}:`, error);
    }
  };

  const refreshPlatform = async (platform) => {
    try {
      await axios.post(`${BACKEND_URL}/api/refresh-platform`, { platform }, {
        withCredentials: true,
      });
      fetchPlatformStatus();
    } catch (error) {
      console.error(`Error refreshing ${platform}:`, error);
      fetchPlatformStatus();
    }
  };

  useEffect(() => {
    fetchPlatformStatus();
    const interval = setInterval(fetchPlatformStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  const platforms = ['tiktok', 'instagram', 'facebook', 'twitter', 'youtube'];

  return (
    <div>
      <h2>Platform Connections</h2>
      {platforms.map(platform => (
        <div key={platform} style={{ marginBottom: '20px' }}>
          <h3>{platform.charAt(0).toUpperCase() + platform.slice(1)}</h3>
          <p>
            Status: {platformStatus.loginStatus[platform] ? 'Connected' : 'Not Connected'}
            {platformStatus.userDetails[platform] && ` (User: ${platformStatus.userDetails[platform]})`}
          </p>
          {platformStatus.validationErrors[platform] && (
            <p style={{ color: 'red' }}>
              Error: {platformStatus.validationErrors[platform]}
            </p>
          )}
          {platformStatus.needsReconnect[platform] && (
            <p style={{ color: 'orange' }}>
              Your connection to {platform} is invalid. Please reconnect.
            </p>
          )}
          <button
            onClick={() => connectPlatform(platform)}
            disabled={platformStatus.loginStatus[platform] && !platformStatus.needsReconnect[platform]}
          >
            {platformStatus.loginStatus[platform] && !platformStatus.needsReconnect[platform]
              ? 'Connected'
              : 'Connect'}
          </button>
          {platformStatus.loginStatus[platform] && !platformStatus.needsReconnect[platform] && (
            <button onClick={() => refreshPlatform(platform)} style={{ marginLeft: '10px' }}>
              Refresh
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default PlatformConnections;